<div class="ispm-checkbox-simple-group">
  <label [ngClass]="widgetConfigPayload.titleClass">{{widgetConfigPayload.title}}</label>
  <section *ngFor="let value of widgetConfigPayload.values;let i = index; trackBy: trackByFn">
    <dls-check-box
            class="select-checkbox"
            [ngClass]="value.cssClass"
            (change)="onSelected(i)"
            [(ngModel)]="selectedItems[i]"
     >{{value.display}}</dls-check-box>
  </section>
</div>